module.exports = "../study/imgs/maps/Tokyo/S8/Helth/Mosquito/Tokyo_Mosquito_GFDL_RCP26_End.png";